import { showConsoleLogs } from '../utils.js';

var PropertyList = /*#__PURE__*/function () {
  /**
   * ID of either a form or a theme
   * @param id
   */

  /**
   * Type is either form or theme
   * @param type
   */

  function PropertyList(opts) {
    this.id = opts.id;
    this.type = opts.type;
    this.properties = opts.properties;

    // we should write a test for this instead
    this._isValid = this.validate();
  }
  var _proto = PropertyList.prototype;
  _proto.reset = function reset(id) {
    if (id === this.id) {
      this.properties.forEach(function (prop) {
        return prop.reset();
      });
    } else {
      throw new Error("Cannot reset properties of " + this.id + " with " + id);
    }
    return this;
  };
  _proto.validate = function validate() {
    var _this = this;
    // verify the types on each property = the type on the property list
    return this.properties.every(function (prop) {
      return prop.type === _this.type;
    });
  };
  _proto.getByName = function getByName(name) {
    return this.properties.find(function (prop) {
      return prop.name === name;
    });
  };
  _proto.findAllBySelector = function findAllBySelector(selector) {
    return this.properties.filter(function (prop) {
      return prop.selector === selector;
    });
  };
  _proto.getByApiPropertyName = function getByApiPropertyName(propertyFromApi) {
    if (showConsoleLogs()) {
      console.groupCollapsed("getByApiPropertyName " + propertyFromApi);
      console.log('this.properties', this.properties);
      console.groupEnd();
    }
    var property = this.properties.find(function (prop) {
      return prop.propertyFromApi === propertyFromApi;
    });
    if (property) {
      return property;
    } else {
      throw new Error("Property " + propertyFromApi + " not found");
    }
  };
  _proto.getNames = function getNames() {
    return [].concat(this.properties.map(function (prop) {
      return prop.name;
    }));
  };
  _proto.getOptions = function getOptions(name) {
    var prop = this.getByName(name);
    return prop ? prop.options : undefined;
  };
  _proto.getOptionKeys = function getOptionKeys(name) {
    var prop = this.getByName(name);
    return prop ? Object.keys(prop.options) : undefined;
  };
  _proto.getDefaultValue = function getDefaultValue(name) {
    var prop = this.getByName(name);
    return prop ? prop.defaultValue : undefined;
  };
  _proto.getValue = function getValue(name) {
    var prop = this.getByName(name);
    return prop ? prop.value : undefined;
  };
  _proto.getCssProperties = function getCssProperties(name) {
    var prop = this.getByName(name);
    return prop ? prop.cssProperties : undefined;
  };
  return PropertyList;
}();

export { PropertyList as default };
//# sourceMappingURL=index.js.map
